import { render, staticRenderFns } from "./strategyTagDrawer.vue?vue&type=template&id=7ce8b497&scoped=true&"
import script from "./strategyTagDrawer.vue?vue&type=script&lang=ts&"
export * from "./strategyTagDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./strategyTagDrawer.vue?vue&type=style&index=0&id=7ce8b497&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce8b497",
  null
  
)

export default component.exports